export interface TourTrashType {
  index?: number;
  id: string;
  title: string;
  status: TourTrashStatusType;
  description: string;
  startDate: string;
  endDate: string;
  product: TourTrashProductType;
  winner: TourTrashWinnerType;
  sendEmailTo?: number;
  pushNotificationTo?: number;
  participationLevel?: string;
  remindPushNotificationFrequency: number;
  sendEmailAtLaunch: boolean;
  pushNotificationAtLaunch: boolean;
  timeToSendEmailBeforeEndDate: number;
  timeToAutoCloseAfterEndDate: number;
  timeToPushNotificationBeforeEndDate: number;
  enteredUsers: boolean;
  countries?: string;
  options?: string;
}

export interface TourTrashProductType {
  id?: string;
  name?: string;
  detail?: string;
  legal?: string;
  images?: TourTrashProductImageType[];
  videoType?: string;
  videoId?: string;
}

export interface TourTrashProductImageType {
  id?: string;
  imageUrl?: string;
}

export interface TourTrashWinnerType {
  id: string;
  email: string;
  fullName: string;
}

export enum TourTrashStatusType {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED',
  COMING_SOON = 'COMING SOON',
  ARCHIVED = 'ARCHIVED',
}

export interface TourTrashForm {
  tourTrashId?: string;
  productId?: string;
  title: string;
  description: string;
  startDate: Date | string | any;
  startTime: Date | string | any;
  endDate: Date | string | any;
  endTime: Date | string | any;
  participationLevel?: number[];
  productDescription?: string;
  productLegal?: string;
  productName?: string;
  productImagePath?: string;
  productVideoId?: string;
  productVideoType?: string;
  sendEmailTo?: number;
  pushNotificationTo?: number;
  remindPushNotificationFrequency: number;
  sendEmailAtLaunch: boolean;
  pushNotificationAtLaunch: boolean;
  timeToPushNotificationBeforeEndDate?: number;
  timeToSendEmailBeforeEndDate?: number;
  timeToAutoCloseAfterEndDate?: number;
  countries?: string;
  options?: any;
}

export interface TourTrashUserType {
  id: string;
  email: string;
  fullName: string;
  myTMSubscriptionLevel: number;
  enteredDate: string;
  spentAmount?: string;
}
